import {push} from 'notivue';
import type {AxiosError} from 'axios';

type ErrorResponse = { message?: string };

export function handleApiError(error: unknown, fallbackMessage = 'There was an error') {
    const err = error as AxiosError;
    const message = (err?.response?.data as ErrorResponse)?.message ?? fallbackMessage;

    push.error({message});
}
